module.exports = __webpack_public_path__ + "assets/new-74d3ba.svg";